// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Popup-module--dialog--3P60E","close":"Popup-module--close--1Sfhu"};